import { render } from "./adminLogin.vue?vue&type=template&id=04d52a0c&ts=true"
import script from "./adminLogin.vue?vue&type=script&lang=ts"
export * from "./adminLogin.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__